module.exports = __webpack_public_path__ + "static/media/fly0123.c241dcf6.webp";